const BROWSER_NOTIFICATION_INPUT = {
  title: 'New notification(s) just arrived.',
  body: 'Click on the little bell icon to find out',
  tag: 'ESSENTIALS_NOTIFICATION',
  vibrate: true
};

export { BROWSER_NOTIFICATION_INPUT };
